import { TrackCheckoutConfig } from '../../../models';

export const DEFAULT_TRACK_CHECKOUT_CONFIG: TrackCheckoutConfig = {
  storage: {
    key: 'checkout',
    ttlInMs:  30 * 24 * 3600 * 1000
  },
};
